<template>
  <div class="modal fade" id="modify_item" data-backdrop="static" tabindex="-1" role="dialog" aria-labelledby="modal-block-vcenter" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-xl" role="document">
      <div class="modal-content">
        <div class="block block-themed block-transparent mb-0">
          <div class="block-header bg-success">
            <h3 class="block-title"><i class="fa fa-cannabis"></i> Add item</h3>
            <div class="block-options">
              <button type="button" @click.prevent="clearData()" class="btn-block-option" data-dismiss="modal" aria-label="Close">
              <i class="fa fa-fw fa-times"></i>
              </button>
            </div>
          </div>
          <transition name="slide-fade">
            <div class="text-center alert-message-top" v-if="errorMsg">
              <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                <div class="alert-message alert-danger alert-error-message">{{errorMsg}}</div>
              </div>
            </div>
          </transition>
          <div class="block-content">
            <div class="row">
              <div class="form-group col-12 col-md-6 col-xl-4 required">
                <label class="control-label">Name</label>
                <input v-model="item.name" name="name" v-validate="'required'" data-vv-as="Name" type="text" class="form-control form-control-alt" placeholder="Enter Item Name">
                <p v-if="errors.has('name')" class="errorMsg">{{ errors.first('name') }}</p>
              </div>
              <div class="form-group col-12 col-md-6 col-xl-4 required">
                <label class="control-label">Select Category</label>
                <select type="text" id="item-category" placeholder="Select Category.." class="form-control item-select2-dropdown" style="width: 100%;">
                  <option></option>
                  <option v-for="(category, i) in library.itemCategories" :key="i" :bind:value="category.Name">{{ category.Name }}</option>
                </select>
                <p v-if="categoryError" class="errorMsg">The Category field is required.</p>
              </div>
              <div class="form-group col-12 col-md-6 col-xl-4 required">
                <label class="control-label">Select Strain</label>
                <select type="text" id="item-strain" placeholder="Select Strain.." class="form-control item-select2-dropdown" style="width: 100%;">
                  <option></option>
                  <option v-for="(strain, i) in library.strains" :key="i" :bind:value="strain.Name">{{ strain.Name }}</option>
                </select>
                <p v-if="strainError" class="errorMsg">The Strain field is required.</p>
              </div>
              <div class="form-group col-12 col-md-6 col-xl-4 required">
                <label class="control-label">Unit Of Measurement</label>
                <select type="text" id="item-unit" placeholder="Select Measurement Unit.." class="form-control item-select2-dropdown" style="width: 100%;">
                  <option></option>
                  <option v-for="(unit, i) in library.unitOfMeasurement" :key="i" :bind:value="unit.Name">{{ unit.Name }}</option>
                </select>
                <p v-if="unitOfMeasureError" class="errorMsg">The Unit Of Measurement field is required.</p>
              </div>
              <div class="form-group col-12 col-md-6 col-xl-4">
                <label>Item Brand</label>
                <select type="text" id="item-brand" placeholder="Select Brand.." class="form-control item-select2-dropdown" style="width: 100%;">
                  <option></option>
                  <option v-for="(brand, i) in library.itemBrands" :key="i" :bind:value="brand.Name">{{ brand.Name }}</option>
                </select>
              </div>
              <div class="form-group col-12 col-md-6 col-xl-4">
                <label>Administration Method</label>
                <input type="text" v-model="item.administrationMethod" class="form-control form-control-alt" placeholder="Administration Method">
              </div>
              <div class="form-group col-12 col-md-6 col-xl-4">
                <label>Unit Cbd Content Unit Of Measure</label>
                <select type="text" id="item-cbd-measure" placeholder="Select Measurement Unit.." class="form-control item-select2-dropdown" style="width: 100%;">
                  <option></option>
                  <option v-for="(unit, i) in library.unitOfMeasurement" :key="i" :bind:value="unit.Name">{{ unit.Name }}</option>
                </select>
              </div>
              <div class="form-group col-12 col-md-6 col-xl-4">
                <label>Unit Cbd Percent</label>
                <input id="unit-cbd-percent" data-skin="round" class="js-rangeslider" type="text" data-min="0" data-max="100" data-from="0" />
              </div>
              <div class="form-group col-12 col-md-6 col-xl-4">
                <label>Unit Cbd Content</label>
                <input type="text" v-model="item.unitCbdContent" class="form-control form-control-alt" placeholder="Unit Thc Content">
              </div>
              <div class="form-group col-12 col-md-6 col-xl-4">
                <label>Unit Thc Content Unit Of Measure</label>
                <select type="text" id="item-thc-measure" placeholder="Select Measurement Unit.." class="form-control item-select2-dropdown" style="width: 100%;">
                  <option></option>
                  <option v-for="(unit, i) in library.unitOfMeasurement" :key="i" :bind:value="unit.Name">{{ unit.Name }}</option>
                </select>
              </div>
              <div class="form-group col-12 col-md-6 col-xl-4">
                <label>Unit Thc Percent</label>
                <input id="unit-thc-percent" data-skin="round" class="js-rangeslider" type="text" data-min="0" data-max="100" data-from="0" />
              </div>
              <div class="form-group col-12 col-md-6 col-xl-4">
                <label>Unit Thc Content</label>
                <input type="text" v-model="item.unitThcContent" class="form-control form-control-alt" placeholder="Unit Thc Content">
              </div>
              <div class="form-group col-12 col-md-6 col-xl-4">
                <label>Unit In Volume</label>
                <input type="text" v-model="item.unitVolume" class="form-control form-control-alt" placeholder="Unit Volume">
              </div>
              <div class="form-group col-12 col-md-6 col-xl-4">
                <label>Unit Volume Unit Of Measure</label>
                <select type="text" id="item-volum-unit-measure" placeholder="Select Measurement Unit.." class="form-control item-select2-dropdown" style="width: 100%;">
                  <option></option>
                  <option v-for="(unit, i) in library.unitOfMeasurement" :key="i" :bind:value="unit.Name">{{ unit.Name }}</option>
                </select>
              </div>
              <div class="form-group col-12 col-md-6 col-xl-4">
                <label>Unit Weight</label>
                <input type="text" v-model="item.unitWeight" class="form-control form-control-alt" placeholder="Unit Weight">
              </div>
              <div class="form-group col-12 col-md-6 col-xl-4">
                <label>Unit Weight Unit Of Measure</label>
                <select type="text" id="item-weight-measure" placeholder="Select Measurement Unit.." class="form-control item-select2-dropdown" style="width: 100%;">
                  <option></option>
                  <option v-for="(unit, i) in library.unitOfMeasurement" :key="i" :bind:value="unit.Name">{{ unit.Name }}</option>
                </select>
              </div>
              <div class="form-group col-12 col-md-6 col-xl-4">
                <label>Serving Size</label>
                <input id="serving-size" data-skin="round" class="js-rangeslider" type="text" data-min="0" data-max="100" data-from="0" />
              </div>
              <div class="form-group col-12 col-md-6 col-xl-4">
                <label>Supply Duration Days</label>
                <input id="supply-duration" data-skin="round" class="js-rangeslider" type="text" data-min="0" data-max="100" data-from="0" />
              </div>
              <div class="form-group col-12 col-md-6 col-xl-4">
                <label>Ingredients</label>
                <input v-model="item.ingredients" type="text" class="form-control form-control-alt" placeholder="Ingredients">
              </div>
              <div class="block-content block-content-full text-right border-top button-loader">
                <button type="button" class="btn btn-sm btn-light" data-dismiss="modal" @click.prevent="clearData()">Close</button>
                <button type="button" class="btn btn-sm btn-primary" @click="modifyItem" :bind:disabled="showModalLoader">
                  <div><i class="fa fa-save mr-1"></i><span>Save</span></div>
                  <span class="modal-loader" v-if="showModalLoader">
                    <hash-loader class="custom-class text-white" color="#fff" loading="loading" size="15" sizeUnit="px"></hash-loader>
                  </span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Vue from 'vue';
import VeeValidate from 'vee-validate';
import { mapState } from 'vuex';
import { VueSpinners } from '@saeris/vue-spinners';
import { HashLoader } from '@saeris/vue-spinners';
import { helper } from '@/helper.js';
import $ from 'jquery';
import * as select2 from 'select2/dist/js/select2.full.js';
import 'select2/dist/css/select2.min.css';
import 'bootstrap-datepicker/dist/js/bootstrap-datepicker.min.js';
import 'bootstrap-datepicker/dist/css/bootstrap-datepicker3.min.css';

Vue.use(VeeValidate, VueSpinners);
export default {
  name: 'ModifyItem',
  data() {
    return {
      item: {
        id: 0,
        name: '',
        category: '',
        strain: '',
        unitOfMeasure: '',
        brand: '',
        administrationMethod: '',
        unitCbdPercent: '',
        unitCbdContent: '',
        unitCbdContentUnitOfMeasure: '',
        unitThcPercent: '',
        unitThcContent: '',
        unitThcContentUnitOfMeasure: '',
        unitVolume: '',
        unitVolumeUnitOfMeasure: '',
        unitWeight: '',
        unitWeightUnitOfMeasure: '',
        servingSize: '',
        supplyDurationDays: '',
        ingredients: ''
      },
      categoryError: false,
      strainError: false,
      unitOfMeasureError: false,
      showModalLoader: false,
      errorMsg: ''
    };
  },
  computed: {
    ...mapState({
      library: state => state.library
    })
  },
  components: {
    HashLoader
  },
  mounted() {
    let vm = this;
    $('.item-select2-dropdown').each(function() {
      $(this).select2({
        dropdownParent: jQuery(this).parent(),
        placeholder: $(this).attr('placeholder')
      });
    });
    $('.datepicker').datepicker({ format: 'yyyy-mm-dd', autoclose: true });
    jQuery('.js-rangeslider').ionRangeSlider();

    $('#item-category').on('change', function () { vm.item.category = $(this).val(); vm.categoryError = false; } );
    $('#item-strain').on('change', function () { vm.item.strain = $(this).val(); vm.strainError = false; } );
    $('#item-unit').on('change', function () { vm.item.unitOfMeasure = $(this).val(); vm.unitOfMeasureError = false;  } );
    $('#item-brand').on('change', function () { vm.item.brand = $(this).val(); } );
    $('#item-cbd-measure').on('change', function () { vm.item.unitCbdContentUnitOfMeasure = $(this).val(); } );
    $('#item-thc-measure').on('change', function () { vm.item.unitThcContentUnitOfMeasure = $(this).val(); } );
    $('#item-volum-unit-measure').on('change', function () { vm.item.unitVolumeUnitOfMeasure = $(this).val(); } );
    $('#item-weight-measure').on('change', function () { vm.item.unitWeightUnitOfMeasure = $(this).val(); } );
  },
  methods: {
    clearData() {
      let vm = this;
      Object.keys(vm.item).map(function(key){ return vm.item[key] = ''; });
      this.errorMsg = '';
      this.updateSelectValues();
      this.updateSlider();
      this.$validator.reset();
    },
    modifyItem() {
      let vm = this;
      this.$validator.validate().then(valid => {
        if (vm.validate() && valid) {
          vm.showModalLoader = true;
          vm.errorMsg = '';
          let action = this.item.id ? 'update' : 'create';
          helper.sendPostRequest('/items/' + action, {
            'Name': vm.item.name,
            'Id': vm.item.id,
            'ItemCategory': vm.item.category,
            'Strain': vm.item.strain,
            'UnitOfMeasure': vm.item.unitOfMeasure,
            'ItemBrand': vm.item.brand,
            'AdministrationMethod': vm.item.administrationMethod,
            'UnitCbdPercent': jQuery('#unit-cbd-percent').val(),
            'UnitCbdContent': vm.item.unitCbdContent,
            'UnitCbdContentUnitOfMeasure': vm.item.unitCbdContentUnitOfMeasure,
            'UnitThcPercent': jQuery('#unit-thc-percent').val(),
            'UnitThcContent': vm.item.unitThcContent,
            'UnitThcContentUnitOfMeasure': vm.item.unitThcContentUnitOfMeasure,
            'UnitVolume': vm.item.unitVolume,
            'UnitVolumeUnitOfMeasure': vm.item.unitVolumeUnitOfMeasure,
            'UnitWeight': vm.item.unitWeight,
            'UnitWeightUnitOfMeasure': vm.item.unitWeightUnitOfMeasure,
            'ServingSize': jQuery('#serving-size').val(),
            'SupplyDurationDays': jQuery('#supply-duration').val(),
            'Ingredients': vm.item.ingredients
          }).then((data) => {
            vm.showModalLoader = false;
            if (data.status === 'success') {
              vm.$emit('loadItems', true);
              jQuery('#modify_item').modal('hide');
              vm.$emit('showSuccessMsg', data.message);
              vm.clearData();
            } else {
              vm.errorMsg = data.message;
            }
          });
        }
      });
    },
    updateSelectValues() {
      let vm = this;
      $('#item-category').val(vm.item.category).trigger('change');
      $('#item-strain').val(vm.item.strain).trigger('change');
      $('#item-unit').val(vm.item.unitOfMeasure).trigger('change');
      $('#item-brand').val(vm.item.brand).trigger('change');
      $('#item-cbd-measure').val(vm.item.unitCbdContentUnitOfMeasure).trigger('change');
      $('#item-thc-measure').val(vm.item.unitThcContentUnitOfMeasure).trigger('change');
      $('#item-volum-unit-measure').val(vm.item.unitVolumeUnitOfMeasure).trigger('change');
      $('#item-weight-measure').val(vm.item.unitWeightUnitOfMeasure).trigger('change');
    },
    updateSlider() {
      let vm = this;
      jQuery('#unit-cbd-percent').data('ionRangeSlider').update({from: vm.item.unitCbdPercent});
      jQuery('#unit-thc-percent').data('ionRangeSlider').update({from: vm.item.unitThcPercent});
      jQuery('#serving-size').data('ionRangeSlider').update({from: vm.item.servingSize});
      jQuery('#supply-duration').data('ionRangeSlider').update({from: vm.item.supplyDurationDays});
    },
    validate() {
      this.strainError = false;
      this.categoryError = false;
      this.unitOfMeasureError = false;

      if (!this.item.strain) {
        this.strainError = true;
      }

      if (!this.item.category) {
        this.categoryError = true;
      }

      if (!this.item.unitOfMeasure) {
        this.unitOfMeasureError = true;
      }

      if (this.categoryError || this.strainError || this.unitOfMeasureError) {
        return false;
      }

      return true;
    },
    loadItem(item) {
      this.item.id = item.Id;
      this.item.name = item.Name;
      this.item.category = item.ProductCategoryName;
      this.item.strain = item.StrainName;
      this.item.unitOfMeasure = item.UnitOfMeasureName;
      //      this.brand = item;
      this.item.administrationMethod = item.AdministrationMethod;
      this.item.unitCbdPercent = item.UnitCbdPercent;
      this.item.unitCbdContent = item.UnitCbdContent;
      this.item.unitCbdContentUnitOfMeasure = item.UnitCbdContentUnitOfMeasureName;
      this.item.unitThcPercent = item.UnitThcPercent;
      this.item.unitThcContent = item.UnitThcContent;
      this.item.unitThcContentUnitOfMeasure = item.UnitThcContentUnitOfMeasureName;
      this.item.unitVolume = item.UnitVolume;
      this.item.unitVolumeUnitOfMeasure = item.UnitVolumeUnitOfMeasureName;
      this.item.unitWeight = item.UnitWeight;
      this.item.unitWeightUnitOfMeasure = item.UnitWeightUnitOfMeasureName;
      this.item.servingSize = item.ServingSize;
      this.item.supplyDurationDays = item.SupplyDurationDays;
      this.item.ingredients = item.Ingredients;
      this.updateSelectValues();
      this.updateSlider();
    },
    ucFirst(string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    }
  }
};
</script>


// WEBPACK FOOTER //
// source/components/modals/ModifyItem.vue